export default function ($api) {
    return {
        getRecipes(query = "") {
            return $api.get(`api/recipe/all${query}`);
        },
        getRecipesTags(query = "") {
            return $api.get(`api/recipe/tags${query}`);
        },
        getRecipeDetail(slug) {
            return $api.get(`api/recipe/one?filters[slug][eq]=${slug}`);
        },
        getRecipeProducts(ids) {
            let query = "";
            ids.forEach((id, i) => {
                query += `${i === 0 ? "" : "&"}filters[id][in][]=${id}`;
            });
            return $api.get(`api/product/all?${query}&filters[eol][null]=1`);
        },
    };
}
